/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Step_RecoveryInputs */

const en_coach_step_recovery = /** @type {(inputs: Coach_Step_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery`)
};

const de_coach_step_recovery = /** @type {(inputs: Coach_Step_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erholung`)
};

/**
* | output |
* | --- |
* | "Recovery" |
*
* @param {Coach_Step_RecoveryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_step_recovery = /** @type {((inputs?: Coach_Step_RecoveryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Step_RecoveryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_step_recovery(inputs)
	return de_coach_step_recovery(inputs)
});